import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TipOfTheDayRoutingModule } from './tip-of-the-day-routing.module';
import { TipOfTheDayComponent } from './tip-of-the-day.component';
import { StaticFooterModule } from 'src/app/modules-ui/layouts';
import { AllAdviceComponent } from './all-advice/all-advice.component';
import { AdviceDayComponent } from './advice-day/advice-day.component';
import { ReturnBtnArrowModule } from '../../modules-ui';
import { TranslocoModule } from '@ngneat/transloco';
import {SharedModule} from '@shared';


@NgModule({
  declarations: [TipOfTheDayComponent, AllAdviceComponent, AdviceDayComponent],
  imports: [
    CommonModule,
    TipOfTheDayRoutingModule,
    TranslocoModule,
    StaticFooterModule,
    ReturnBtnArrowModule,
    SharedModule,
  ]
})
export class TipOfTheDayModule { }
